import type { ReactNode } from 'react';

import { Flex, cn } from '@kognitos/lattice';

/**
 * Props for {@link AssetDefinitionLayout}.
 */
export interface IAssetDefinitionLayoutProps {
  /**
   * The chat and the document, normally a `ResizablePanelGroup` the page owns
   * so it keeps its own panel sizing.
   */
  children: ReactNode;
  /** The configuration rail on the right, normally an `AssetConfigRail`. */
  rail?: ReactNode;
  className?: string;
  'data-testid'?: string;
}

/**
 * The Definition view of an asset: the builder chat on the left, the asset's
 * document in the middle and its configuration rail on the right. The page
 * supplies the panels; this owns how they sit together.
 */
export function AssetDefinitionLayout({
  children,
  rail,
  className,
  'data-testid': dataTestId = 'asset-definition-layout',
}: IAssetDefinitionLayoutProps) {
  return (
    <Flex
      align="stretch"
      gap={4}
      // The page column sizes children to content, which pushes the rail off-screen.
      width="full"
      className={cn('min-h-0 min-w-0 flex-1 bg-layout', className)}
      data-testid={dataTestId}
    >
      <Flex align="stretch" className="min-h-0 min-w-0 flex-1">
        {children}
      </Flex>
      {rail}
    </Flex>
  );
}
